import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table} from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser, formataDataExibicao} from '../../common/utils';
import Swal from 'sweetalert2'
import Paginacao from '../../common/pagination';

class CodVeeva extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);     
        this.onClickPagina = this.onClickPagina.bind(this);   

        this.state = {
            listRegistros: [],
            error: "",
            loading: true,
            filtro_sem_cod_veeva: false,
            filtro_cod_veeva: '',
            page_numb: 1,
        };
    }

    handleChangeFiltros = (event, fieldName) => {                
        if(fieldName == 'filtro_sem_cod_veeva'){
            this.setState({ filtro_sem_cod_veeva: event.target.checked });
        }
        else {            
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    componentDidMount(){      
        this.setState({
            filtro_sem_cod_veeva: false,
            filtro_cod_veeva: ''
        }, () => {
            this.consultaRegistros();
        });
    }

    consultaRegistros(page_numb=1){     
        let filtros = `?page=${page_numb}&sem_cod_veeva=1`; 
    
        if(this.state.filtro_cod_veeva){
            filtros += `&cod_veeva=${this.state.filtro_cod_veeva}`;
        }
    
        api.get(`/atendimentos/veeva/${filtros}`)
        .then(response => {
            const dados = response.data;
            this.setState({
                loading: false,
                error: "",
                listRegistros: dados,
                filtro_status: true
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar os atendimentos, tente novamente.';
            if(error.response.status === 500){
                erro_msg = 'Serviço indisponível no momento, por favor tente novamente mais tarde';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }
            this.setState({
                loading: false,
                error: erro_msg,
                filtro_status: true
            });
        });
    }

    onChangeCodVeeva = async (e, atendimento_id, campo_cod_veeva) => {     
        if(!e.target.value){
            return
        }

        // Loading de verificação
        Swal.fire({
            title: 'Verificando...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        //Request de verificação antes da confirmação
        const { data } = await api.get(`/atendimentos/veeva/?cod_veeva=${e.target.value}`);
        
        // fecha o loading
        Swal.close();

        let html_alerta = ''
        let icon = ''

        // Se retornou algo
        if (data && data.count > 0) {
            html_alerta = `<p>Já existe um atendimento com o mesmo Cód. Veeva informado</p> `;

            Swal.fire({
                icon: 'warning',
                title: "Atenção!",
                html: html_alerta,
                showCloseButton: true,
            });

            return;
        }

        html_alerta = `<p>Deseja confirmar a atualização deste Cód. Veeva?</p>`
        icon = 'info'

        Swal.fire({
            title: 'Confirmar ação?',
            icon: icon,
            html: html_alerta,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',       
        }).then((result) => {
            if (result.isConfirmed) {                
                Swal.fire({
                    title: 'Salvando...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const list_valores = [
                    {
                        valor: e.target.value, 
                        campo_id: campo_cod_veeva, 
                        file_param: "",
                        log: 'cod_veeva'
                    }
                ]                
                const payload = {
                    'valores': list_valores
                }

                // Envia a requisição PUT para atualizar o atendimento
                api.put(`/atendimentos/extra_campos/${atendimento_id}/`, payload)
                .then((response) => {                    
                    this.setState(prevState => ({
                        listRegistros: {
                            ...prevState.listRegistros,
                            results: prevState.listRegistros.results.map(item =>
                            item.atendimento_id === atendimento_id
                                ? { 
                                    ...item, 
                                    cod_veeva: e.target.value
                                }
                                : item
                            ),
                        },
                    }));

                    // Fecha o loading e exibe o alerta de sucesso
                    Swal.fire({
                        icon: "success",
                        title: "Sucesso",
                        text: "Registro atualizado com sucesso.",
                    });
                })
                .catch((error) => {
                    console.error("Erro ao atualizar relato:", error);
                    // Fecha o loading e exibe o alerta de erro
                    Swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: "Não foi possível atualizar o regitro. Tente novamente.",
                    });
                });         
            }
        });        
    };

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {            
            return this.state.listRegistros.results.map((item) =>                
                <tr key={item.atendimento_id}>
                    <td>{item.atendimento_id}</td>
                    <td>{item.patologia}</td>
                    <td>
                        {
                        item.cod_veeva ? 
                        item.cod_veeva :
                        <Form.Control
                            type="text"
                            name="cod_veeva"
                            maxLength={5}
                            onBlur={e => this.onChangeCodVeeva(e, item.atendimento_id, item.campo_cod_veeva)}
                        />
                        }
                    </td>
                    <td>{formataDataExibicao(item.dt_entrada)}</td>
                    <td>{item.status_atendimento}</td>
                    <td>{item.motivo_status_psp}</td>
                    <td>{item.grupo_etario}</td>
                    <td>{item.idade_beneficiario}</td>
                    <td>{item.genero_beneficiario}</td>
                    <td>{item.cidade_beneficiario}</td>
                    <td>{item.uf_beneficiario}</td>
                    <td>{item.nome_medico}</td>
                    <td>{item.nome_medico_assistente}</td>
                </tr>
            );
        }
        else {
            return (
                <tr>
                    <td colSpan={13}>Nenhum atendimento encontrado</td>
                </tr>
            );
        }
        
    };
    
    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistros(num_page)
    };

    filtrarCodVeeva = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.consultaRegistros()
    };
    
    render() {
        if (!hasPerm('view_ultracarePspAtendimentosCompleto')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Atendimentos Cód Veeva</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Id Aditus</th>
                                    <th>Diagnóstico</th>
                                    <th>VEEVA</th>
                                    <th>Data de entrada</th>
                                    <th>Status do Programa</th>
                                    <th>Motivo do Status</th>
                                    <th>Grupo etário</th>
                                    <th>Idade</th>
                                    <th>Gênero</th>
                                    <th>Cidade</th>
                                    <th>Estado</th>
                                    <th>Médico responsável</th>
                                    <th>Médico assistente</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={13}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={13}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                           
                            </tbody>
                        </Table>
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                                         
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(CodVeeva);